/** @jsxImportSource @emotion/react */
import React from 'react'
import { SerializedStyles } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

interface DropdownArrowIconProps {
  size?: number
  color?: string
  style?: SerializedStyles
}

const DropdownArrowIcon: React.FC<DropdownArrowIconProps> = ({
  size = 24,
  color = colors.NEUTRAL_0,
  style,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${size}px`}
      height={`${size}px`}
      viewBox='0 0 24 24'
      fill='none'
      css={style}
    >
      <path
        d='M12 14.975C11.8667 14.975 11.7377 14.95 11.613 14.9C11.4877 14.85 11.3834 14.7834 11.3 14.7L6.70005 10.1C6.51672 9.91672 6.42505 9.68338 6.42505 9.40005C6.42505 9.11671 6.51672 8.88338 6.70005 8.70005C6.88338 8.51672 7.11672 8.42505 7.40005 8.42505C7.68338 8.42505 7.91672 8.51672 8.10005 8.70005L12 12.6L15.9 8.70005C16.0834 8.51672 16.3167 8.42505 16.6 8.42505C16.8834 8.42505 17.1167 8.51672 17.3 8.70005C17.4834 8.88338 17.575 9.11671 17.575 9.40005C17.575 9.68338 17.4834 9.91672 17.3 10.1L12.7 14.7C12.6 14.8 12.4917 14.8707 12.375 14.912C12.2584 14.954 12.1334 14.975 12 14.975Z'
        fill={color}
      />
    </svg>
  )
}

export default DropdownArrowIcon
